var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('application-layout-fluid',{staticClass:"price-optimizer-view",attrs:{"data-testid":"price-optimizer-view"}},[_c('h1',{staticClass:"mb-3"},[_vm._v("Asking Rates")]),_c('v-divider'),_c('price-optimizer-search')],1)}
var staticRenderFns = []

export { render, staticRenderFns }